/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationPostureResponse {
    getFixupPrototypeFunction() { return OperationPostureResponse.fixupPrototype; }

    static newInstance(model: Partial<OperationPostureResponse>): OperationPostureResponse {
        let obj = Object.assign(new OperationPostureResponse(), model);
        OperationPostureResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationPostureResponse>): OperationPostureResponse {
        if (!model) return null;
        return OperationPostureResponse.newInstance(<OperationPostureResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationPostureResponse) {
        if (!obj) return;

        models.OperationPostureResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationPostureResponse): boolean {
        Object.setPrototypeOf(obj, OperationPostureResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.tenants) {
            for (let val of this.tenants) {
                models.OperationPostureTenant.fixupPrototype(val);
            }
        }
        if (this.cloud_account_data) {
            for (let val of this.cloud_account_data) {
                models.OperationPostureCloudData.fixupPrototype(val);
            }
        }
        if (this.clouds) {
            for (let val of this.clouds) {
                models.OperationPostureCloudProvider.fixupPrototype(val);
            }
        }
    }

    /**
     * count details
     */
    total_count: number;

    /**
     * List of tenant data
     */
    tenants: Array<models.OperationPostureTenant>;

    /**
     * List of cloud account data
     */
    cloud_account_data: Array<models.OperationPostureCloudData>;

    /**
     * List of tenant data
     */
    clouds: Array<models.OperationPostureCloudProvider>;

}
